import { Component, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_CHECKBOX_CLICK_ACTION, MatDialog, MatRadioChange } from '@angular/material';
import { DataApiService } from '../../Services/data-api.service';
import { DataUserService } from '../../Services/data-user.service';
import * as moment from 'moment';
import { MapsService } from 'src/app/Services/maps.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { AltaDemandaComponent } from '../dialogs/alta-demanda/alta-demanda.component';
import { from } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { MatCheckboxChange } from '@angular/material';
interface Hour { id: number, hora: string }

@Component({
  selector: 'app-nuevo-envio',
  templateUrl: './nuevo-envio.component.html',
  styleUrls: ['./nuevo-envio.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check' }
  ]
})

export class NuevoEnvioComponent implements OnInit {
  constructor(
    private dataApi: DataApiService,
    private DataUser: DataUserService,
    private dialog: MatDialog,
    private mapService: MapsService,
    private snackBar: MatSnackBar
  ) { }

  tipoUsuario = localStorage.getItem("type"); convenio = localStorage.getItem("convenio");

  public form = {
    idUser: this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token"))),
    id_ciudad: this.encontrarRegion(localStorage.getItem("region")),
    tipoPedido:1,
    infoPedido: [
      { fecha: null, hora: null, direccion: null, contacto: null },
      { fecha: null, hora: null, direccion: null, contacto: null, descripcion: null },
      { direccion: null, contacto: null, descripcion: null },
      { direccion: null, contacto: null, descripcion: null },
      { direccion: null, contacto: null, descripcion: null }
    ],
    RUCFactura: null,
    RazonSocialFactura: null,
    kilometros:null,
    precio_prev: 0,
    descuento: 0,
    porcentaje_descuento: 0,
    precio_descuento: 0,
    precio: null,
    precio_convenio: null,
    cod_desc: null,
    checkboxContraentrega: false,
    liquidado: 0,
    convenio: 0,
    cargo: false,

  }
  public finalPrice: any;

  //ViewChild
  @ViewChild('map') map: any;
  @ViewChild('placesRef0') placesRef0: any;
  @ViewChild('placesRef1') placesRef1: any;
  @ViewChild('placesRef2') placesRef2: any;
  @ViewChild('placesRef3') placesRef3: any;
  @ViewChild('placesRef4') placesRef4: any;


  public options: any = {
    componentRestrictions: { country: 'co' },
    fields: ["place_id", "address_components", "name", "formatted_address", "geometry"],
    strictBounds: true,
  };



  directionsService = new google.maps.DirectionsService();
  directionsRenderer = new google.maps.DirectionsRenderer({
    suppressMarkers: true,
    polylineOptions: {
      strokeColor: "#ff0000",
      strokeOpacity: 1,
      strokeWeight: 3
    }
  });

  
  onCheckboxChange(event: MatRadioChange) 
  {
    if (event.value === 2) {
      this.snackBar.open(
        'Se considerará un tiempo de 15 a 20 minutos para cada trámite.','',
        {
          duration: 5000
        }
      );
      this.group2 = false; this.group3 = false; this.group4 = false;
      this.add1 = false; this.add2 = false; this.add3 = false;
      this.delete2 = false; this.delete3 = false; this.delete4 = false;
      this.form.infoPedido[2].direccion =  null;
      this.form.infoPedido[2].contacto =  null;
      this.form.infoPedido[2].descripcion =  null;
      this.form.infoPedido[3].direccion =  null;
      this.form.infoPedido[3].contacto =  null;
      this.form.infoPedido[3].descripcion =  null;
      this.form.infoPedido[4].direccion =  null;
      this.form.infoPedido[4].contacto =  null;
      this.form.infoPedido[4].descripcion =  null;  
      this.waypts = [];      
      this.destination = this.locations[1]["latlng"]; 
    } else {      
      this.snackBar.dismiss();
      this.add1 = true;      
    }
    this.locations =  this.locations.slice(0, 2);
    console.log(this.locations);
    this.newPositionMap(null, this.destination);
    this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);
    


  
  }


  seleccionarDirecion(address: any, index: number): void {

    this.rellenarValoresDirecciones(index);
    this.buildingLocations(address, index);
    this.newPositionMap(address, null);
    this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);

    if (index === 0 || index === 1) {
      if (this.locations[0] != undefined && this.locations[1] !== undefined) {
        this.add1 = true;
      }
    } else if (index === 2) {
      this.add2 = true;
    } else if (index === 3) {
      this.add3 = true;
    }

  }

  rellenarValoresDirecciones(index: number): void {
    switch (index) {
      case 0:
        this.form.infoPedido[0].direccion = this.placesRef0.nativeElement.value;
        break;
      case 1:
        this.form.infoPedido[1].direccion = this.placesRef1.nativeElement.value;
        break;
      case 2:
        this.form.infoPedido[2].direccion = this.placesRef2.nativeElement.value;
        break;
      case 3:
        this.form.infoPedido[3].direccion = this.placesRef3.nativeElement.value;
        break;
      case 4:
        this.form.infoPedido[4].direccion = this.placesRef4.nativeElement.value;
        break;
    }
  }


  locations: any = [];
  origin: any = [];
  destination: any = [];
  waypts: any = [];

  buildingLocations(address: any, index: number) {
    this.waypts = [];

    if (this.form.checkboxContraentrega == true) {
      this.locations.pop();
      this.form.checkboxContraentrega = !this.form.checkboxContraentrega;
    }

    this.locations[index] = {
      "addrees": address.formatted_address,
      "latlng": { lat: address.geometry.location.lat(), lng: address.geometry.location.lng() },
      "icon": `assets/iconsMarkerMaps/${(index == 0 ? "marker1" : "marker2")}.png`,
      "indexMarker": index + 1,
      "setMarker": true,
      "kilometraje": 0
    };

    this.origin = this.locations[0]["latlng"];

    for (let i = 1; i < this.locations.length - 1; i++) {
      this.waypts[i - 1] = { location: this.locations[i]["latlng"], stopover: true }
    }

    this.destination = this.locations[this.locations.length - 1]["latlng"];

  }

  showGroup2(): void {
    if (this.consultBeforeNewRoute(this.form.infoPedido[0], this.form.infoPedido[1])) {
      this.mapService.alertForm();
    } else {
      this.add1 = false;
      this.group2 = true;
      this.delete2 = true;
    }
  }
  showGroup3(): void {
    if (this.consultBeforeNewRoute(this.form.infoPedido[2])) {
      this.mapService.alertForm();
    } else {
      this.add2 = false; this.group3 = true; this.delete2 = false; this.delete3 = true;
    }
  }
  showGroup4(): void {
    if (this.consultBeforeNewRoute(this.form.infoPedido[3])) {
      this.mapService.alertForm();
    } else {
      this.add3 = false; this.group4 = true; this.delete3 = false; this.delete4 = true;
    }
  }

  consultBeforeNewRoute(datos1, datos2 = null) {
    let count1 = 0;
    let count2 = 0;
    for (let prop in datos1) {
      if (datos1[prop] === null || datos1[prop] === "") {
        count1++;
      }
    }
    if (datos2 != null) {
      for (let prop in datos2) {
        if (datos2[prop] === null || datos2[prop] === "") {
          count2++;
        }
      }
    }
    return (count1 + count2) !== 0 ? true : false;
  }


  hideGroup(indexGroup): void {
    this.form.infoPedido[indexGroup] = { direccion: null, contacto: null, descripcion: null };

    if (indexGroup == 2) {
      this.add1 = true; this.group2 = false; this.delete2 = true;
    } else if (indexGroup == 3) {
      this.add2 = true; this.group3 = false; this.delete2 = true; this.delete3 = false;
    } else if (indexGroup == 4) {
      this.add3 = true; this.group4 = false; this.delete3 = true; this.delete4 = false;
    }


    if (this.form.checkboxContraentrega == true) {
      this.locations.pop();
      this.form.checkboxContraentrega = !this.form.checkboxContraentrega;
    }

    if (this.locations[indexGroup] !== undefined) {
      this.locations.pop();
    }

    this.waypts = [];
    this.destination = this.locations[this.locations.length - 1]["latlng"];

    for (let i = 1; i < this.locations.length - 1; i++) {
      this.waypts[i - 1] = { location: this.locations[i]["latlng"], stopover: true }
    }

    this.newPositionMap(null, this.destination)
    this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);
  }

  group2: boolean = false; group3: boolean = false; group4: boolean = false;

  add1: boolean = false; add2: boolean = false; add3: boolean = false;
  delete2: boolean = false; delete3: boolean = false; delete4: boolean = false;


  newPositionMap(address: Address, choordsDestine: any): void {
    let choords = choordsDestine == null ? { lat: address.geometry.location.lat(), lng: address.geometry.location.lng() } : choordsDestine;
    let mapa = new google.maps.Map(this.map.nativeElement, {
      zoom: 14,
      center: choords,
      disableDefaultUI: true
    });
    this.directionsRenderer.setMap(mapa);
    this.setMarkers(mapa);

  }

  
  setMarkers(map: google.maps.Map): void {
    for (let i = 0; i < this.locations.length; i++) {
      const { addrees, latlng, icon, indexMarker, setMarker } = this.locations[i];
      new google.maps.Marker({
        position: latlng,
        map,
        icon: (setMarker == true) ? icon : null,
        title: addrees,
        zIndex: indexMarker,
        animation: google.maps.Animation.DROP,
        draggable: false,
      });
    }
  }

  public oficinaARecojo: any = 0;
  calculateOficinaARecojo(directionsService: any): Promise<number> {

    return new Promise<number>((resolve) => {
      directionsService
        .route({
          origin: this.mapService.direccionOficina,
          destination: this.locations[0]["latlng"],
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .then((response) => resolve(response))
        .catch((e) => console.log("Directions request failed due to " + e));
    })

  }




  calculateAndDisplayRoute(directionsService: any, directionsRenderer: any): void {
    const hora = this.form.infoPedido[0].hora;
    from(this.calculateOficinaARecojo(this.directionsService)).subscribe(result => this.oficinaARecojo = result)

    if (this.locations[0] != undefined && this.locations[1] !== undefined) {

      directionsService
        .route({
          origin: this.origin,
          destination: this.destination,
          optimizeWaypoints: false,
          waypoints: this.waypts,
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC
        })
        .then((response) => {
          directionsRenderer.setDirections(response);
          let routes = response.routes[0].legs;
          this.finalPrice = this.mapService.calculatePrize(this.oficinaARecojo, routes);
          this.obtenerPrecios(this.finalPrice);

        })
        .catch((e) => console.log("Directions request failed due to " + e));
    }
  }
  obtenerPrecios(finalPrice: any): void 
  {
    const horarioRecojo = this.form.infoPedido[0].hora;
    this.form.precio_prev = this.obtenerPrecioPedido(finalPrice);
    this.form.precio = this.obtenerPrecioPedido(finalPrice);
    this.form.cargo = this.tieneCargo(horarioRecojo,finalPrice);
    this.form.kilometros = finalPrice["distance"];

  }


  obtenerPrecioPedido(finalPrice:any): number 
  {
    const horarioRecojo = this.form.infoPedido[0].hora;
    const tipopedido =  this.form.tipoPedido;
    const obtenerPrecioCargoNocturno = this.obtenerPrecioCargoNocturno(horarioRecojo,finalPrice);
    const precioTipoPedido = this.obtenerPrecioTipoPedido(tipopedido,finalPrice);
    const precio = Number(finalPrice["precioBase"]) + Number(finalPrice["precioDistanciaRecorrida"] + Number(obtenerPrecioCargoNocturno) + Number(precioTipoPedido));
    return this.redondearAFavor(precio);

  }

  obtenerPrecioTipoPedido(tipoPedido:number,finalprice:any):number{
    if(tipoPedido == 1){
      return 0;
    }else if(tipoPedido ==2){
      return finalprice["precioTramite"];
    }else{
      return 0;
    }
    
  }

  obtenerPrecioCargoNocturno(horaRecojo:any,finalPrice:any): number 
  {
    let precioHorarioNocturno = 0;
    const horaRecojoFormat = moment(horaRecojo, "HH:mm:ss").format("HH:mm:ss");
    const horaCargoNocturnoInicio = moment(finalPrice["horaCargoNocturnoInicio"], "HH:mm:ss").format("HH:mm:ss");
    const horaCargoNocturnoFinal = moment(finalPrice["horaCargoNocturnoFinal"], "HH:mm:ss").format("HH:mm:ss");

    if (horaRecojo) {
      if (horaCargoNocturnoFinal <= horaRecojoFormat && horaRecojoFormat < horaCargoNocturnoInicio) {
        precioHorarioNocturno = 0;
      } else {
        precioHorarioNocturno = finalPrice["precioCargoNocturno"]
      }
    } else {
      precioHorarioNocturno = 0;
    }

    return precioHorarioNocturno;
  }

  tieneCargo(horaRecojo: string, finalPrice:any): boolean {

   const horaRecojoFormat = moment(horaRecojo, "HH:mm:ss").format("HH:mm:ss");
    const horaCargoNocturnoInicio = moment(finalPrice["horaCargoNocturnoInicio"], "HH:mm:ss").format("HH:mm:ss");
    const horaCargoNocturnoFinal = moment(finalPrice["horaCargoNocturnoFinal"], "HH:mm:ss").format("HH:mm:ss");

    if (horaRecojo) {
      if (horaCargoNocturnoFinal <= horaRecojoFormat && horaRecojoFormat < horaCargoNocturnoInicio) {
        return false
      } else {
        return true
      }
    } else {
      return false;
    }
  }




  redondearAFavor(num: number) {
    return Math.ceil(num / 100) * 100;
  }



  contraentrega(): void {
    this.waypts = [];

    if (this.form.checkboxContraentrega == false) {
      this.locations[this.locations.length] = this.locations[0];
      this.form.checkboxContraentrega = !this.form.checkboxContraentrega;

    } else {
      this.locations.pop();
      this.form.checkboxContraentrega = !this.form.checkboxContraentrega;
    }

    this.destination = this.locations[this.locations.length - 1]["latlng"];

    for (let i = 1; i < this.locations.length - 1; i++) {
      this.waypts[i - 1] = { location: this.locations[i]["latlng"], stopover: true }
    }
    this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer)

  }

  encontrarRegion(region:any):number
  {
      return region ? region : 0;
  }

  ngOnInit() {

   
    this.mapService.preciosPedido();

    new google.maps.Map(this.map.nativeElement, { zoom: 13, center: this.mapService.getChoords, disableDefaultUI: true, });
    const direcciones = [this.placesRef0, this.placesRef1, this.placesRef2, this.placesRef3, this.placesRef4];

    direcciones.forEach((el, index) => {

      const direccion = el.nativeElement;
      const autocompletado = new google.maps.places.Autocomplete(direccion, this.options);
      google.maps.event.addListener(autocompletado, 'place_changed', () => {
        this.form.infoPedido[index].direccion = direccion.value;
      })

    })


  }

  minDate = this.compararHoras();
  showHoursRecojo: Hour[];
  showHoursEntrega: Hour[];

  mostrarHorarios() {
    const daySelected = moment(this.form.infoPedido[0].fecha).format("YYYY-MM-DD");
    this.form.infoPedido[0].hora = null;
    this.form.infoPedido[1].fecha = null;
    this.form.infoPedido[1].hora = null;

    this.dataApi.mostrarHorarios(daySelected).subscribe((data: Hour[]) => {
      this.showHoursRecojo = data["horarios"];
    })
  }

  mostrarHorariosEntrega() {
    this.form.infoPedido[1].hora = null;
    const horariosEntrega = (moment(this.form.infoPedido[0].fecha).format("YYYY-MM-DD") === moment(this.form.infoPedido[1].fecha).format("YYYY-MM-DD"))
      ? this.form.infoPedido[0].hora
      : "all";
    this.dataApi.mostrarHorariosEntrega(horariosEntrega).subscribe((data: Hour[]) => this.showHoursEntrega = data["horarios"]
    )
  }

  minDiaRecojo(numDia) {
    return moment().add(numDia, 'days')
  }

  compararHoras() {
    return ("18:31:00" < moment().format("HH:mm:00")) ? this.minDiaRecojo(1) : this.minDiaRecojo(0);
  }

  cargo: boolean = false;

  setDateTimeToGroupIndex1(): void {

    this.configurarFechaYHoraEntrega();
    this.obtenerPrecios(this.finalPrice);

  }

  configurarFechaYHoraEntrega(): void {
    this.form.infoPedido[1].fecha = this.form.infoPedido[0].fecha;

    const datetime = moment(this.form.infoPedido[0].hora, "HH:mm:ss");

    this.dataApi.mostrarHorariosEntrega(this.form.infoPedido[0].hora).subscribe((data: Hour[]) => this.showHoursEntrega = data["horarios"])

    this.form.infoPedido[1].hora = String(datetime.add(1, 'hours').format("HH:mm:ss"));
  }


  dateAfterRecojo = null;
  ofechaRecojo(e: any): void {
    this.dateAfterRecojo = moment(this.form.infoPedido[0].fecha).format("YYYY-MM-DD")
  }


  showResume: boolean = false;

  onSubmit(): void {
    this.showResume = true;
  }
  regresar(): void {
    this.showResume = false;
  }

  formatDate(date: any): string {
    return moment(date).format("YYYY-MM-DD");
  }

}
